import Api from "@/services/service-v2";

export const buildConfig = (payload) => {
  let url = `/cap/users/tenant/set-build-config/${payload.tenant}/${payload.type}`;

  if (payload.type !== "web" && payload.appType) {
    url += `?appType=${payload.appType}`;
  }
  return Api().$http.post(url, payload.data);
};

export const buildGenerate = (payload) =>
  Api().$http.post(`/cap/users/application-build/build/generate`, payload);

export const getExecutionId = (type, id) =>
  Api().$http.get(`/cap/users/application-build/builds/stage/${type}/${id}`);

export const getBuildProgress = (buildId) =>
  Api().$http.get(`/cap/users/application-build/builds/phases/${buildId}`);

export const getBuildStatus = (payload) =>
  Api().$http.get(`/cap/users/application-build/detail/${payload.id}`);

export const getSystemConfiguration = () =>
  Api().$http.get(`/cap/users/system-config/fetch`);

export const addWebhook = (payload) =>
  Api().$http.post(`/webhook/register-tenant`, payload);

export const addWebhookEvent = (payload) =>
  Api().$http.post(`/webhook/add-webhook-event`, payload);

export const webhookEventList = (payload) =>
  Api().$http.get(`/webhook/event-list/${payload.id}`);

export const deleteEvent = (payload) =>
  Api().$http.put(`/webhook/event-delete/${payload.id}`);

export const updateTenantProfile = (id, payload) =>
  Api().$http.put(`cap/users/tenant/update-tenant/${id}`, payload);

export const mapDomain = (payload) =>
  Api().$http.post(`cap/users/tenant/certificate/request`, payload);

export const updateBuildApplication = (id, payload) =>
  Api().$http.put(`cap/users/application-build/update/${id}`, payload);

export const eventList = () => Api().$http.get(`/ webhook / events.json`);
export const getMarket = (userId) => {
  return Api().$http.get(
    "/catalog/api/catalog/read/catalog/tenant-business-segments",
    {
      headers: {
        "x-encrypted-key": userId,
      },
    }
  );
};